import { FC } from 'react';
import { Button, HStack, Icon, useBoolean } from '@wegroup/design-system';
import useQueryParams from '@common/src/hooks/useQueryParams';
import SelectionOverviewAnvaOfferButton from '@flows/src/components/flow-products/quotes/basket/actions/SelectionOverviewAnvaOfferButton';
import { useTranslation } from 'react-i18next';
import { useFlowsSession } from '@flows/src/api/getFlowsSessionById';
import useStartAnvaContractFlow from '@sales-conversation/src/hooks/anva/useStartAnvaContractFlow';

interface Props {
  flowId?: string;
}

const BottomBarSelectionOverviewActions: FC<Props> = ({ flowId }) => {
  const { t } = useTranslation();
  const queryParams = useQueryParams();
  const sessionId = queryParams.get('session_id') || '';
  const { data: session } = useFlowsSession(sessionId);
  const startContractFlow = useStartAnvaContractFlow();
  const [isLoading, setIsLoading] = useBoolean();

  const handleNavigation = async () => {
    if (!flowId || !session) return;
    setIsLoading.on();
    await startContractFlow({
      flowId,
      anva_products: session.anva_products || [],
      uuid: sessionId,
    });
    setIsLoading.off();
    return;
  };

  return (
    <HStack spacing="4" ml="auto">
      <SelectionOverviewAnvaOfferButton
        sessionId={sessionId}
        isPlural={
          !!session?.anva_products && session?.anva_products?.length > 1
        }
      />
      <Button
        flexShrink={0}
        ml="auto"
        onClick={handleNavigation}
        rightIcon={<Icon name="GeneralActionsArrowRight" />}
        isLoading={isLoading}
      >
        {t('FLOWS_PRODUCTS_SELECTION-OVERVIEW_ACTION')}
      </Button>
    </HStack>
  );
};

export default BottomBarSelectionOverviewActions;
